const data = [
  { 
    'id':'1',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/traffic.png',
    'value': 'Well-maintained Vehicles',
  },
  { 
    'id':'2',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/tag.png',
    'value': 'Punctual Pickups',
  },
  {
    'id':'3',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/247Support.png',
    'value': '24/7 Customer Support',
  },
];

export default data;



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationSearch/uvpData.js